export default {
  parameters: {
    landing_id: "ItAbFC",
  },
  newDesign: true,
  title: "Coding FreeCourse | Italy",
  downtimeUrl: "https://cl.kodland.tech",
  startPage: {
    startBackground: "white",
    quizBackground: "#white",
    title:
      "Rispondi a 5 domande e ricevi un invito a un CORSO DI INFORMATICA GRATUITO!",
    subtitle:
      "Tuo figlio/a creerà il proprio gioco e noi gli mostreremo come sfruttare il suo interesse per la tecnologia in modo positivo.",
    image: {
      url: "/welcome/freec_italy_desktop.png",
      style: {
        height: "100%",
        "max-height": "100vh",
      },
    },
    imageMobile: {
      url: "/welcome/freec_italy_mob.png",
      style: {
        width: "100%",
      },
    },
    button: " Registrati ora 🔥 ",
  },
  // successPage: {
  //   title: "¡Felicitaciones! 🎁",
  //   subtitle: "Haz clic en '📆 Reservar una clase' para completar el registro",
  //   button: "📆 Reservar una clase",
  // },
  stopPage: {
    image: "/welcome/quizV2/no-computer.png",
    title: "Grazie per aver scelto la nostra piattaforma educativa!",
    subtitle:
      "Sfortunatamente, tablet o telefoni non sono adatti per seguire le nostre lezioni. Saremo felici di vedervi nelle nostre lezioni la prossima volta!",
  },
  quizRotateBySteps: {
    1: {
      question: "Quanto tempo trascorre tuo/a figlio/a con i dispositivi elettronici al giorno?",
      answers: [
        "1 ora 😍",
        "2-3 ore 😃",
        "Più di 4 ore 😐",
      ],
    },
    2: {
      question: "Qual è la personalità di tuo/a figlio/a?",
      subtitle: "La risposta ci aiuterà a scegliere la corretta metodologia di insegnamento",
      answers: [
        "Attivo, comunica tanto 🥳",
        "Timido 🫢",
        "Sognatore 🥰",
        "Tranquillo, trascorre molto tempo da solo 🤫",
        "Non sa bene cosa vuole 🤔",
        "La mia proposta (Te la dirò in classe) ❓"
      ],
    },
    3: {
      question: "Cosa è importante per te durante una lezione",
      answers: [
        "Entrare in contatto con tuo/a figlio/a 👨‍👩‍👦",
        "Abilità utili per il futuro 👨‍💻",
        "Vedere risultati immediati 😎",
        "Atmosfera amichevole 😊",
        "La motivazione e l’interesse del/la bambino/a ⚡",
        "Una piattaforma di apprendimento comoda 🖥️"
      ],
    },
    4: {
      question: "Come valuti la motivazione di tuo/a figlio/a ad apprendere?",
      answers: [
        "Alta 😄",
        "Normale 🤔",
        "Bassa 😌"
      ],
    },
    5: {
      title: "Quanti anni ha tuo figlio/a?",
      type: "age",
      button: "",
    },
    6: {
      question: "Hai un computer/portatile per studiare?",
      answers: [
        "Sì ✔️",
        {
          answer: "No ❌",
          stopAnswer: true,
        },
      ],
    },
    7: {
      title: "Congratulazioni! 🎉",
      typeInfo: "congrats",
      subtitle:
        "Clicca su '📆 Prenota una lezione' per completare la registrazione. Ti invieremo un video corso e l'accesso alla nostra piattaforma non appena riceveremo la tua richiesta.",
      button: "📆 Prenota una lezione",
    },
    8: {
      title: "Prenota una lezione gratuita",
      type: "one-page-contacts",
      subtitle: "",
      button: "👏 Perfetto. Manca l'ultimo passaggio!",
    },
    9: {
      title: "",
      type: "timeslot",
      subtitle: "",
      button: "",
    },
    10: {
      title:
        "Controlla questi dettagli per completare la registrazione ✨",
      typeInfo: "pc-laptop",
      subtitle:
        "Ti ricordiamo che per la lezione avrai bisogno di un PC o laptop funzionante e che dovrai accompagnare tuo figlio per tutta la lezione. Ricorda che è individuale e personalizzato.",
      button: "Cos'altro?",
    },
    11: {
      title: "Controlla la tua email e WhatsApp prima della lezione di prova 📞",
      typeInfo: "whatsapp",
      subtitle:
        "24 ore prima della lezione ti invieremo un promemoria e 2 ore prima della lezione ti chiederemo di confermare la tua presenza. È molto importante rimanere in contatto affinché la lezione non venga annullata.",
      button: "Cos'altro?",
    },
    12: {
      title: "La lezione si svolgerà sulla nostra piattaforma 💻",
      typeInfo: "classroom",
      subtitle:
        "Riceverai un link e un codice univoco via WhatsApp ed email. Basta cliccare sul link, ti porterà direttamente alla lezione. Senza app aggiuntive e senza download.",
      button: "Ho capito ✅",
    }
  },
};
